import { useAuth } from '../../context/auth-context'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import useSubordinateMeetings from '../../graphql/meeting/hooks/useSubordinateMeetings'
import { SubordinateMeetingsTable } from './SubordinateMeetingsTable'
import { MeetingViewInfoBox } from './infoBox/MeetingViewInfoBox'
import { Meeting } from '../../types'

export const SubordinateMeetingsContainer: React.FC = () => {
  const { user } = useAuth()
  const { data, error, loading } = useSubordinateMeetings(user.employeeId)

  if (loading || error || !data || !data.subordinateMeetings) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} />
  }

  return (
    <>
      <MeetingViewInfoBox data={data.subordinateMeetings} />
      <SubordinateMeetingsTable tableData={data.subordinateMeetings as Meeting[]} />
    </>
  )
}
